<template>
  <div class="operate-tips">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="isDeleteVisible"
      width="30%"
      center
    >
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">{{$t('components.confirm')}}</el-button>
        <el-button type="outline" @click="isDeleteVisible = false"
          >{{$t('components.cancel')}}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      isDeleteVisible: false,
      dialogTitle: "",
    };
  },
  mounted() {},
  methods: {
    confirm() {
      this.isDeleteVisible = false;
      this.$emit("sureDel");
    },
    cancel() {
      this.isDeleteVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
// 修改dialog样式
::v-deep {
  .el-dialog {
    &__header {
      margin-top: 32px;
    }
    &__body {
      display: none;
    }
    &__footer {
      margin-top: 16px;
    }
  }
}

// 手机端响应式布局修改
@media screen and (max-width: 600px) {
  ::v-deep {
    // 弹窗面板
    .el-dialog {
      width: 380px;
      background: #fff;
      border-radius: 8px;
      padding: 30px;
    }

    // 弹窗主题内容
    .el-dialog__body {
      margin: 0;
      padding: 0;
    }
  }

  // 关闭符号
  .dialog-close {
    position: relative;
    top: -24px;
    left: 150px;
  }
}
</style>
